// src/components/HelpGuide.jsx
import React, { useEffect } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import HelpServiceInfo from "../elements/HelpServiceInfo";
import UsageTranslate from "../elements/UsageTranslate";
import UsageDocSearch from "../elements/UsageDocSearch";
import UsageInsightAnalyze from "../elements/UsageInsightAnalyze";
import UsageAgentElva from "../elements/UsageAgentElva";
import { ChevronLeft } from "lucide-react";
import AshGuide from "../elements/AshGuide";
import VirtualBizLabGuide from "../elements/VirtualBizLabGuide";
import MainHeader from "../MainHeader";

export default function HelpGuide() {
  // Dashboard 라우트에서는 실제 "page" 파라미터가 sessionId로 넘어올 수 있으므로
  const { page: explicitPage, sessionId } = useParams();
  const page = explicitPage ?? sessionId;
  const navigate = useNavigate();

  /* 메뉴 정의 */
  const nav = [
    { slug: "service", label: "서비스 소개", element: <HelpServiceInfo /> },
    {
      slug: "usage_translate",
      label: "번역 시스템 사용법",
      element: <UsageTranslate />,
    },
    {
      slug: "usage_doc_search",
      label: "문서 딥 리서치 사용법",
      element: <AshGuide />,
    },
    {
      slug: "usage_insight_analyze",
      label: "AI 인사이트 분석 사용법",
      element: <UsageInsightAnalyze />,
    },
    {
      slug: "virtual_biz_labs",
      label: "VirtualBizLab(AI 가상회사)",
      element: <VirtualBizLabGuide />,
    },
    {
      slug: "usage_agent_elva",
      label: "AgentElva란?",
      element: <UsageAgentElva />,
    },
  ];

  /* 현재 선택된 메뉴 */
  const current = nav.find((n) => n.slug === page) || nav[0];

  /* 잘못된 slug → 리다이렉트 */
  useEffect(() => {
    if (!page || page !== current.slug) {
      navigate(`/help_guide/${current.slug}`, { replace: true });
    }
  }, [page, current.slug, navigate]);

  return (
    <>
      <MainHeader />
      <header className="flex items-center px-4 py-3 border-b bg-gray-100">
        <button
          onClick={() => navigate("/app")}
          className="flex items-center text-gray-700 hover:text-gray-900"
        >
          <ChevronLeft className="w-5 h-5 mr-1" />
          뒤로가기
        </button>
      </header>
      <div className="flex w-full h-full bg-white">
        {/* 좌측 네비게이션 */}
        <aside className="w-56 border-r bg-gray-50 p-4 space-y-2">
          {nav.map((n) => (
            <NavLink
              key={n.slug}
              to={`/help_guide/${n.slug}`}
              className={({ isActive }) =>
                `block px-3 py-2 rounded text-sm font-medium transition ${
                  isActive
                    ? "bg-indigo-600 text-white"
                    : "text-gray-700 hover:bg-gray-100"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </aside>

        {/* 콘텐츠 영역 */}
        <main className="flex-1 p-6 overflow-auto">{current.element}</main>
      </div>
    </>
  );
}
